<template>
  <IndexPanel
    v-if="listItems?.length > 0"
    :initialData="listItems"
    :modelValue="searchResults"
    operationType="shafts"
  />
  <OperationList
    v-slot="slotProps"
    :listItems="searchResults"
    operationType="shafts"
  >
    <OperationList
      v-if="slotProps && slotProps.item.listItem.mines"
      v-slot="slotProps2"
      innerGroup
      :listItems="slotProps.item.listItem.mines"
      operationType="shafts"
    >
      <OperationItem
        v-for="item in slotProps2.item.listItem.shafts"
        :id="item.id"
        :key="item.id"
        barChart
        endpointIdentifier="shafts"
        :itemRoutes="{
          view: { name: 'shaftDashboard', params: { shaftId: item.id } },
          edit: { name: 'editShaft', params: { shaftId: item.id } },
        }"
        :organisationId="organisationId"
      />
    </OperationList>
  </OperationList>
</template>

<script setup>
import { onMounted, ref, watch, computed } from 'vue';
import useAjax from '@/functions/use_ajax';

// Components
import OperationList from '@/components/operations/operations_list.vue';
import OperationItem from '@/components/operations/operation_item.vue';
import IndexPanel from '@/components/form/index_panel.vue';

const emit = defineEmits(['update']);

const props = defineProps({
  organisationId: { type: String, default: null },
});

const ajax = useAjax();
const listItems = ref([]);
const loading = ref(true);
const searchResults = ref([]);

const itemCount = computed(() => {
  let mineShaftLength = 0;
  return searchResults.value?.reduce(function (_, obj) {
    mineShaftLength += obj.mines?.reduce(function (acc, obj2) {
      return acc + (obj2.shafts?.length || 0);
    }, 0);
    return mineShaftLength;
  }, 0);
});

onMounted(load);

watch(props, load);
watch(itemCount, emitCount);

function emitCount() {
  emit('update', {
    count: itemCount.value || 0,
    label: 'shafts',
    loading: loading.value,
  });
}

async function load() {
  await loadShafts();
  loading.value = false;

  emitCount();
}

async function loadShafts() {
  let { ok, data } = await ajax(`/organisations/${props.organisationId}/shafts`);

  if (ok) {
    listItems.value = JSON.parse(JSON.stringify(data.divisions));
    searchResults.value = data.divisions;
  }
}
</script>
